import React, { useEffect, useState } from 'react'
import SavingPlans from '../../Components/Save/SavingPlans'
import Savings from '../../Components/Save/Savings'
import Topsec from '../../Components/Save/TopSec'
import SavingSuccess from '../../Components/Save/SavingSuccess'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

function Save() {
  const location = useLocation()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [type, setType] = useState('target')
  const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    if (location.state?.showSuccess) {
      setOpen(true)
      setType(location.state?.planType || 'target')
      setRefreshKey(prev => prev + 1)
      navigate(location.pathname, { replace: true, state: {} })
    }
  }, [location, navigate])

  return (
    <div>
      <SavingSuccess
        open={open}
        handleClose={() => setOpen(false)}
        type={type}
      />
      <Topsec />
      <Savings key={`savings-${refreshKey}`} />
      <SavingPlans />
      <Outlet />
    </div>
  )
}

export default Save